module.exports = __webpack_public_path__ + "img/ok.44fd48fe.png";